import pick from 'lodash/pick';
import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { paginationFields } from '@/models/pagination.model';
import { showApiErrors } from '@/utils';
import {
  getGoogleMerchantSyncRuns,
  syncGoogleMerchantDelta,
  syncGoogleMerchantFull,
  syncGoogleMerchantProduct,
} from './actionCreators';
import { SLICE_NAME, IGoogleMerchantSyncState, initialState } from './models';

export const googleMerchantSyncSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGoogleMerchantSyncRuns.pending, (state: IGoogleMerchantSyncState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getGoogleMerchantSyncRuns.fulfilled, (state: IGoogleMerchantSyncState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.syncRuns = payload.items;
        state.pagination = pick(payload, paginationFields);
      })
      .addMatcher(
        isRejected(
          getGoogleMerchantSyncRuns,
          syncGoogleMerchantFull,
          syncGoogleMerchantDelta,
          syncGoogleMerchantProduct,
        ),
        (state: IGoogleMerchantSyncState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;
          showApiErrors(error);
        },
      )
      .addMatcher(
        isPending(syncGoogleMerchantFull, syncGoogleMerchantDelta, syncGoogleMerchantProduct),
        (state: IGoogleMerchantSyncState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isFulfilled(syncGoogleMerchantFull, syncGoogleMerchantDelta, syncGoogleMerchantProduct),
        (state: IGoogleMerchantSyncState) => {
          state.isLoading = false;
        },
      );
  },
});
